import { Text, View, StyleSheet } from '@react-pdf/renderer';
import React from 'react';

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '14px',
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.8cm',
    paddingBottom: '0.3cm',
    borderBottom: '2px solid #548235',
  },
  closingText: {
    fontSize: '11px',
    color: '#34495e',
    lineHeight: 1.5,
    textAlign: 'justify',
    marginBottom: '1cm',
    fontStyle: 'italic',
  },
  signatureContainer: {
    backgroundColor: '#f8f9fa',
    borderRadius: '0.3cm',
    border: '1px solid #e8e8e8',
    padding: '1cm',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  signatureName: {
    fontSize: '14px',
    fontFamily: 'Helvetica-Bold',
    color: '#2c3e50',
    marginBottom: '0.2cm',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  signatureTitle: {
    fontSize: '11px',
    color: '#7f8c8d',
    fontStyle: 'italic',
    marginBottom: '0.1cm',
  },
  signaturePosition: {
    fontSize: '11px',
    color: '#7f8c8d',
    marginBottom: '0.4cm',
  },
  companyName: {
    fontSize: '13px',
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    marginBottom: '0.2cm',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  contactInfo: {
    fontSize: '10px',
    color: '#7f8c8d',
    lineHeight: 1.3,
  },
  website: {
    fontSize: '10px',
    color: '#548235',
    fontFamily: 'Helvetica-Bold',
    marginBottom: '0.1cm',
  },
});

function BudgetFinish({ config, staticData }) {
  return (
    <View>
      <Text style={styles.title}>6. Cierre</Text>

      {/* Texto de cierre */}
      <Text style={styles.closingText}>
        Esperando una buena acogida del presente informe y a la espera de sus noticias, no nos queda
        más que agradecer su interés y esperamos contar con su confianza.
      </Text>

      {/* Contenedor de firma */}
      <View style={styles.signatureContainer} wrap={false}>
        {/* Nombre del titular */}
        <Text style={styles.signatureName}>{staticData?.titular ?? ''}</Text>

        {/* Título profesional */}
        <Text style={styles.signatureTitle}>{staticData?.titular_titulo ?? ''}</Text>

        {/* Cargo */}
        <Text style={styles.signaturePosition}>{staticData?.titular_cargo ?? ''}</Text>

        {/* Línea separadora */}
        <View
          style={{
            width: '100%',
            height: '1px',
            backgroundColor: '#e8e8e8',
            marginBottom: '0.4cm',
          }}
        />

        {/* Información de la empresa */}
        <Text style={styles.companyName}>{config?.company ?? ''}</Text>

        {/* Sitio web */}
        <Text style={styles.website}>{config?.web ?? ''}</Text>

        {/* Teléfonos */}
        {config?.telefonos?.map((telefono) => (
          <Text style={styles.contactInfo} key={telefono}>
            {telefono}
          </Text>
        ))}
      </View>
    </View>
  );
}

export default BudgetFinish;
